import React, {useEffect, useState} from "react";
import {Button, Typography} from "@mui/material";
import css_self from "./css/Pages.module.scss";
import enterpriseObjectClassFactory from "../eoec/EnterpriseObjectClassFactory";
import EnterpriseObject from "../eoec/eo/EnterpriseObject";
import ProjectMilestoneSessionTableApplet from "../eoec/applet/impl/Session/ProjectMilestoneSessionTableApplet";
import ProjectMilestoneAuditHistoryTableApplet from "../eoec/applet/impl/Session/ProjectMilestoneAuditHistoryTableApplet";



export default function MyCres() {
    const [viewOption, setViewOption] = React.useState<string | null>("Settings");
    const [projectMilestoneSessionEnterpriseObject] = useState(enterpriseObjectClassFactory("ProjectMilestoneSession") as EnterpriseObject);

    useEffect(() => {

        return () => {
        }
    });

    let menus = (
        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
            <div style={{paddingTop: "10px", marginLeft: "30px"}}>
                <div style={viewOption === "Settings" ? {paddingBottom: "4px", borderBottom: "2px solid #525968"} : {borderBottom: "0px solid #525968"}}>
                    <Button className={css_self.NavMenuButton} variant="text" onClick={() => {
                        setViewOption("Settings")
                    }}>Settings</Button>
                </div>
            </div>
            <div style={{paddingTop: "10px", marginLeft: "30px"}}>
                <div style={viewOption === "Audit History" ? {paddingBottom: "4px", borderBottom: "2px solid #525968"} : {borderBottom: "0px solid #525968"}}>
                    <Button className={css_self.NavMenuButton} variant="text" onClick={() => {
                        setViewOption("Audit History")
                    }}>Audit History</Button>
                </div>
            </div>
        </div>
    );

    let auditHistory = (
        <div style={{display: "flex", flexDirection: "column", backgroundColor: "#FFFFFF", height: "100vh", paddingRight: "60px"}}>
            <div style={{paddingLeft: "30px", paddingTop: "30px", width: "100%"}}>
                <ProjectMilestoneSessionTableApplet enterpriseComponent={projectMilestoneSessionEnterpriseObject?.getEnterpriseComponent("ProjectMilestoneSession")} PageSize={{
                    "default": 5,
                }}/>
            </div>
            <div style={{paddingLeft: "30px", paddingTop: "30px", width: "100%"}}>
                <ProjectMilestoneAuditHistoryTableApplet enterpriseComponent={projectMilestoneSessionEnterpriseObject?.getEnterpriseComponent("ProjectMilestoneAuditHistory")} PageSize={{
                    "default": 20,
                }}/>
            </div>
        </div>
    );


    return (
        // minHeight: 100% so the page FILLS the window and anything drawn down its edge -- a panel
        // separator, a column rule -- runs the whole way rather than stopping where the content
        // happens to end. NOT a fixed height: this page has no scroll region of its own, so a fixed
        // height would clip whatever ran past the fold with no way to reach it. minHeight fills when
        // the content is short and grows when it is long; the shell scrolls it either way.
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1, minHeight: "100%"}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#1498D8"}}>
                <div style={{paddingTop: "9px", paddingLeft: "20px"}}>
                    <Typography style={{fontSize: 24, fontWeight: 400, color: "#FFFFFF"}}>My ParkourAI</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                </div>
            </div>
            {menus}
            {viewOption === "Audit History" ? (auditHistory) : null}
        </div>
    );
}